<app-authorization-enabled></app-authorization-enabled>
<app-technical-alerts></app-technical-alerts>

@if (!isStandalone) {
	<app-mobile-label-create-notification></app-mobile-label-create-notification>
}

<div class="outside-layout">
	<div class="outside-layout__main-content">
		<app-login-header
			[context]="'only-for-mobile'"
			[logoColor]="'#ffffff'"
		></app-login-header>

		<div class="outside-layout__form-block">
			<div class="outside-layout__form">
				<ng-content select="[form-selector]"></ng-content>
			</div>
		</div>
		<div class="outside-layout__slider-block">
			<app-login-ad-slider></app-login-ad-slider>
		</div>
	</div>
	<app-login-main-info class="outside-layout__main-info"></app-login-main-info>
	<app-login-footer></app-login-footer>
</div>
